
















































































import axios from 'axios';
import Vue from 'vue';

import router from '../../router';
import { store } from '../../store';
import Utils from '../../Utils';
import LoadingHelper from '../../utils/loadingHelper';

import Loader from '../../components/Loader.vue';
import Navbar from '../../components/Navbar.vue';
import TextField from '../../components/TextField.vue';

export default Vue.extend({
  components: {
    Loader,
    Navbar,
    TextField,
  },
  computed: {
    hasComeFromEmail(): boolean {
      return !!(this.resetToken && this.resetEmail);
    },
  },
  data() {
    return {
      email: '',
      hasSentEmail: false,
      loadingReset: false,
      password: '',
    };
  },
  methods: {
    async resetPassword() {
      const isValid = await this.$validator.validate();
      if (!isValid) {
        Utils.toastError('New password is invalid.');
        return;
      }

      const timer = new LoadingHelper(1000);

      timer.onComplete = success => {
        this.loadingReset = false;

        if (success) {
          this.hasSentEmail = true;
          Utils.toastSuccess('Password reset successfully');

          store.setJwt(success);
          router.push('/');
        } else {
          Utils.toastError(
            'An unknown error has occured. Please try again later.'
          );
        }
      };

      timer.onError = err => {
        Utils.toastError('An unknown error has occured. Try again later');
      };

      this.loadingReset = true;
      timer.start();

      try {
        const res = await axios.post(
          // @ts-ignore
          `${process.env.VUE_APP_API_URI}/api/auth/passwordreset`,
          {
            email: this.resetEmail,
            token: this.resetToken,
            password: this.password,
          }
        );

        if (res.status) {
          timer.complete(res.data);
        } else {
          timer.complete(false);
        }
      } catch (err) {
        timer.complete(false);
      }
    },
    async sendResetEmail() {
      const isValid = await this.$validator.validate();
      if (!isValid) {
        Utils.toastError('Email is invalid');
        return;
      }

      const timer = new LoadingHelper(1000);

      timer.onComplete = success => {
        this.loadingReset = false;

        if (success) {
          this.hasSentEmail = true;
        } else {
          Utils.toastError(
            'An unknown error has occured. Please try again later.'
          );
        }
      };

      timer.onError = err => {
        Utils.toastError('An unknown error has occured. Try again later');
      };

      this.loadingReset = true;
      timer.start();

      try {
        const res = await axios.post(
          // @ts-ignore
          `${process.env.VUE_APP_API_URI}/api/auth/requestpasswordreset`,
          {
            email: this.email,
          }
        );

        if (res.status) {
          timer.complete(true);
        } else {
          timer.complete(false);
        }
      } catch (err) {
        timer.complete(false);
      }
    },
  },
  name: 'resetPassword',
  props: {
    resetToken: {
      type: String,
      default: '',
    },
    resetEmail: {
      type: String,
      default: '',
    },
  },
});
